import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../components/Loading";
import DropdownMenu from './components/Dropdown'
import _, { set, times, wrap } from 'lodash';
import RemoveSvg from '../../svgs/RemoveSvg'
import RefreshButton from '../../svgs/RefreshButton'
import SaveButton from '../../svgs/SaveButton'
import FileDropzone from '../../components/FileDropzone'
import { uploadPhoto } from "../../services/documents";
import ContentEditor from './components/ContentEditor'
import { fetchPromotionById, fetchPromotions, updatePromotion, deletePromotion } from "../../services/promotions";
import PromotionPreview from './components/PromotionPreview'
import { getImageFileAspectRatio } from "../../utils/util";
import { fetchContentByKey, updateContentById } from "../../services/contents";

const TABS = ['文章管理', '文章內容', '文章預覽'];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState({})
    useEffect(() => {
        fetchData()
    }, [props.token, id])


    async function fetchData() {
        let res = await fetchPromotionById(id)
        if (res.result) {
            setData(res.result)
        }
    }
    const refresh = async () => {
        fetchData()
    }
    const onDropImageFile = (field) => async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        const aspectRatio = field==='hero'? 600/350:600/300//await getImageFileAspectRatio(file);

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, `${field}_${Math.floor(Math.random() * 1000)}`);
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                await updatePromotion(props.token?.token, id, { [field]: filepath, ...field === 'hero' ? { heroAspectRatio: aspectRatio } : {} });
                setData({ ...data, [field]: filepath, heroAspectRatio: aspectRatio });
            }
        }
        setIsloading(false);
    }

    const save = async () => {
        if (!data.name || data.name.length < 3) {
            alert('文章名稱長度需大於3')
            return
        }
        setIsloading(true)
        let res = await updatePromotion(props.token?.token, id, {
            name: data.name,
            status: data.status,
            order: data.order,
            content: data.content || [],
            tags: data.tags || [],
            categories: data.categories || [],
            thumbnail: data.thumbnail || null,
            hero: data.hero || null,
            heroAspectRatio: data.heroAspectRatio || null,
            isStarPrivilege: !!data.isStarPrivilege,
            isPremiumPrivilege: !!data.isPremiumPrivilege,
        });
        if (res.errno) {
            alert(res.message || '更新失敗')
        } else {
            alert('更新成功')
            refresh()
        }
        setIsloading(false);
    }

    const [tab, setTab] = useState(TABS[0])



    {/*introduction handler*/ }
    const handleContentOrder = (field) => (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data[field][oldIndex]);
        }
        let d = { ...data };
        d[field] = array;
        setData(d);
    }
    const handleAddContent = (field) => () => {
        let d = { ...data };
        let c = [...(d[field] || [])]
        c.push({ id: Date.now(), type: 'text', content: '', isTitle: false })
        d[field] = c
        setData(d);
    }
    const handleSectionDeleteContent = (field) => (card, cardIndex) => {
        let d = { ...data }
        let c = d?.[field] || [];
        c.splice(cardIndex, 1);
        d[field] = c;
        setData(d)
    }
    const handleSectionEditContent = (field) => (card, cardIndex, key, value) => {
        let d = { ...data };
        d[field][cardIndex][key] = value
        setData(d);
    }
    {/*introduction handler*/ }

    const [isDeleting, setIsDeleting] = useState(false)
    const handleDelete = async () => {
        setIsloading(true)
        let res = await deletePromotion(props.token?.token, id)
        if (res.errno) {
            alert(res.message || '刪除失敗')
            setIsloading(false)
        } else {
            alert('刪除成功')
            navigate('/cms/contents') // Navigate back to the contents list page
        }
    }

    const handleCopyToHomepage = (contentField) => async () => {
        const result = await fetchContentByKey('homepage_content')
        if (result?.result?.[0]) {
            setIsloading(true)
            let homePageContent = result.result[0];
            let newContent = [...(homePageContent?.[contentField] || []),{
                id: data?._id,
                type: 'card-01',
                image: data?.thumbnail || '',
                description: data?.name || '',
                isStarPrivilege: !!data?.isStarPrivilege,
                isPremiumPrivilege: !!data?.isPremiumPrivilege,
                redirect: {
                    type: 'in-app',
                    path: 'PROMOTION_ARTICLE',
                    params:{
                        _id: data?._id
                    }
                },
                data:[],
                title:'',
                subtitle:'',
                location:'',
            }];

            const newData = {
                [contentField]: newContent,
            }
            let res = await updateContentById(props.token?.token, homePageContent._id, newData)
            setIsloading(false)
            if (res.errno) {
                alert(res.message ? JSON.stringify(res.message) : '更新失敗')
            } else {
                alert('複製成功')
            }

        }
    }

    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] gap-[16px]" style={{ overflowY: 'auto' }}>
            <div className="w-full flex flex-row gap-[16px] flex-wrap p-[16px] relative justify-between">
                <div className="font-[700] text-[24px] z-[2] flex flex-col gap-[4px]">
                    <div>{data.name}</div>
                    <div className="text-[12px] font-[400]">內容管理 {`>`} 路徑參數:{id}</div>
                </div>
                <div className="flex flex-row items-center gap-[8px] z-[2] justify-end flex-1">
                    <div onClick={navigateTo(`/cms/contents`)} className="cursor-pointer hover:opacity-[.5] text-white font-[700] text-[22px] px-[12px] py-[4px] rounded-[8px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                        返回
                    </div>
                    <div onClick={() => { setIsDeleting(true) }} className="cursor-pointer hover:opacity-[.5] text-white font-[700] text-[22px] px-[12px] py-[4px] rounded-[8px]" style={{ background: 'linear-gradient(180deg, #8C706B 0%, rgba(140, 112, 107, 0.2) 100%)' }}>
                        刪除
                    </div>
                    <div onClick={save} className="cursor-pointer hover:opacity-80">
                        <SaveButton />
                    </div>
                    <div onClick={refresh} className="cursor-pointer hover:opacity-80">
                        <RefreshButton />
                    </div>
                </div>
                <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{ background: 'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)' }} />
            </div>
     
            <div className="w-full flex flex-row gap-[16px] flex-wrap px-[16px]">
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#0F737E' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #0F737E' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
            </div>

            {tab === '文章管理' && <div className="w-full flex flex-col gap-[16px] px-[16px]">
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>文章名稱</div>
                        <input value={data?.name || ''} onChange={(e) => { setData({ ...data, name: e.target.value }) }} placeholder='商品名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>


                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>文章狀態</div>
                        <DropdownMenu options={['已公開', '草稿']}
                            value={data?.status === 'published' ? '已公開' : '草稿'}
                            select={(item, index) => {
                                setData({ ...data, status: item === '已公開' ? 'published' : 'draft' })
                            }}
                        />
                    </div>

                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>標籤 - 星級會員禮遇</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isStarPrivilege ? '是' : '否'}
                            select={(item, index) => {
                                setData({ ...data, isStarPrivilege: item === '是' ? true : false })
                            }}
                        />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>標籤 - 尊享會員禮遇</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isPremiumPrivilege ? '是' : '否'}
                            select={(item, index) => {
                                setData({ ...data, isPremiumPrivilege: item === '是' ? true : false })
                            }}
                        />
                    </div>


                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 顯示順序（數值越大，顯示越前）</div>
                        <input value={data?.order ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 99
                            setData({ ...data, order: num < 0 ? 0 : num })
                        }} placeholder='顯示順序' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>

                    <div className='flex-[2] flex flex-col gap-[8px] max-w-[600px] min-w-[500px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 生活服務標籤 </div>
                        <div className="flex flex-row items-center justify-start gap-[8px]">
                            {['為您推薦', '每週熱門', '最高瀏覽', '最多收藏', '人氣推介']?.map((item, index) =>
                                <div key={index} onClick={() => {
                                    let d = { ...data }
                                    if (d.tags?.includes(item)) {
                                        d.tags = d.tags.filter((i) => i !== item)
                                    } else {
                                        d.tags = [...(d.tags || []), item]
                                    }
                                    setData(d)
                                }} className='cursor-pointer flex flex-row items-center justify-start gap-[8px] border-[1px] border-[#00000099] rounded-[4px] px-[8px] py-[4px] bg-[white]' style={{ opacity: data.tags?.includes(item) ? 1 : 0.5 }}>
                                    {item}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className='flex-[2] flex flex-col gap-[8px] max-w-[616px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>生活服務類別</div>
                        <div className="w-full flex flex-row gap-[8px] flex-wrap">
                            {[
                                { label: '住宿', type: 'accommodation' },
                                { label: '餐飲', type: 'food' },
                                { label: '交通', type: 'travel' },
                                { label: '購物', type: 'shopping' },
                                { label: '醫療', type: 'medical' },
                                { label: '教育', type: 'education' },
                            ]?.map((item, index) =>
                                <div key={index} onClick={() => {
                                    let categories = data?.categories || []
                                    if (categories.includes(item.type)) {
                                        categories = categories.filter((type) => type !== item.type)
                                    } else {
                                        categories.push(item.type)
                                    }
                                    setData({ ...data, categories })
                                }} className="cursor-pointer text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] items-center flex flex-row" style={{ border: '1px solid #000', backgroundColor: data?.categories?.includes(item.type) ? '#6E604C' : '#ccc', color: data?.categories?.includes(item.type) ? 'white' : 'black', opacity: data?.categories?.includes(item.type) ? 1 : 0.5 }}>
                                    {item.label}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                        <div className='font-[700]'>資訊卡封面圖片 (600px*300px)</div>
                        <div className="w-full flex flex-row gap-[8px]">
                            {data?.thumbnail && <div className='relative w-full'>
                                {
                                    data?.thumbnail
                                        ? <img style={{ height: undefined, width: '100%', aspectRatio:600/300, objectFit: 'cover' }} src={data?.thumbnail} alt='image' />
                                        : <div>
                                        </div>
                                }
                                <div onClick={() => { setData({ ...data, thumbnail: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                    <RemoveSvg />
                                </div>
                            </div>}
                            <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                <FileDropzone onDropFile={onDropImageFile('thumbnail')} data={data} />
                            </div>
                        </div>
                    </div>
                    <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                        <div className='font-[700]'>文章內容 - 置頂圖片 (600px*350px)</div>
                        <div className="w-full flex flex-row gap-[8px]">
                            {data?.hero && <div className='relative w-full'>
                                {
                                    data?.hero
                                        ? <img style={{ height: undefined, width: '100%', aspectRatio:600/350, objectFit: 'cover' }} src={data?.hero} alt='image' />
                                        : <div>
                                        </div>
                                }
                                <div onClick={() => { setData({ ...data, thumbnail: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                    <RemoveSvg />
                                </div>
                            </div>}
                            <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                <FileDropzone onDropFile={onDropImageFile('hero')} data={data} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='w-full flex flex-col min-w-[400px] gap-[8px] mt-[8px]'>
                    <div className='font-[700]'>快速複製按鈕</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {[{ title: '為您推薦', contentField: 'contents_recommnedations' },
                        { title: '專題', contentField: 'contents_projects' },
                        { title: '活動', contentField: 'contents_events' },
                        { title: '服務', contentField: 'contents_services' },
                        { title: '推廣', contentField: 'contents_promotions' },]?.map((item, index) =>
                            <button key={index} onClick={handleCopyToHomepage(item?.contentField)} className="text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] items-center flex flex-row justify-center hover:opacity-[0.8]" style={{ backgroundColor: '#0F737E', color: 'white' }}>
                                複製到首頁: {item.title}
                            </button>
                        )}

                    </div>
                </div>
            </div>}


            {tab === '文章內容' &&
                <div className="w-full flex flex-col gap-[16px]">
                    <ContentEditor
                        data={data}
                        field={'content'}
                        textField={'data'}
                        allowImageRedirect={true}
                        allowAddEvent={true}
                        refresh={refresh}
                        hideRefresh={true}
                        onDelete={handleSectionDeleteContent('content')}
                        onAddCard={handleAddContent('content')}
                        onEditKey={handleSectionEditContent('content')}
                        updateOrder={handleContentOrder('content')}
                        save={updatePromotion}
                        hideSave={true}
                    />
                </div>}

            {tab === '文章預覽' && <PromotionPreview data={data} />}

            {isDeleting && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white p-8 rounded-lg shadow-lg w-[400px]">
                    <h2 className="text-xl font-bold mb-4">確認刪除</h2>
                    <p className="mb-4">您確定要刪除這篇文章嗎？此操作無法撤銷。</p>
                    <div className="flex justify-end gap-[8px]">
                        <button onClick={() => { setIsDeleting(false) }} className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400">
                            取消
                        </button>
                        <button onClick={handleDelete} className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">
                            刪除
                        </button>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
